import { Editor, Transforms } from 'slate';
import { createLinkElement } from '../utilities.mjs';

/**
 * Insert new link at range
 */
function insertLink(editor, data, at) {
  if (!at) {
    // Insert link at the end of the document
    const point = Editor.end(editor, []);
    Transforms.insertNodes(editor, createLinkElement(data, data.url), {
      at: {
        anchor: point,
        focus: point
      }
    });
    Transforms.select(editor, Editor.end(editor, []));
    return;
  }

  // Wrap range in a new link
  Transforms.wrapNodes(editor, createLinkElement(data), {
    at,
    split: true
  });
}

export { insertLink };
